"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpPerformQuestionRepetition = void 0;
const FormQuestionType_1 = __importDefault(require("@opsbase/lib-form/FormQuestionType"));
const getEnabledQuestions_1 = __importDefault(require("@opsbase/lib-form/helpers/getEnabledQuestions"));
const getScore_1 = __importDefault(require("@opsbase/lib-form/helpers/getScore"));
const isInSection_1 = __importDefault(require("@opsbase/lib-form/helpers/isInSection"));
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const usePerform_1 = __importDefault(require("@opsbase/react-ctrl-perform/PerformController/usePerform"));
const usePerformQuestion_1 = __importDefault(require("@opsbase/react-ctrl-perform/PerformQuestionController/usePerformQuestion"));
const usePerformQuestionActions_1 = __importDefault(require("@opsbase/react-ctrl-perform/PerformQuestionController/usePerformQuestionActions"));
const useAltForSelfLang_1 = __importDefault(require("@opsbase/react-ctrl-self/helpers/useAltForSelfLang"));
const useSelf_1 = require("@opsbase/react-ctrl-self/useSelf");
const useCallforward_1 = __importDefault(require("@opsbase/react-hooks/useCallforward"));
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const AddIcon_1 = __importDefault(require("@opsbase/web-icons/icons/AddIcon"));
const DeleteIcon_1 = __importDefault(require("@opsbase/web-icons/icons/DeleteIcon"));
const InfoIcon_1 = __importDefault(require("@opsbase/web-icons/icons/InfoIcon"));
const Horizontal_1 = __importDefault(require("@opsbase/web-layout/Horizontal"));
const Pane_1 = __importDefault(require("@opsbase/web-layout/Pane/Pane"));
const Vertical_1 = __importDefault(require("@opsbase/web-layout/Vertical"));
const Accordion_1 = __importDefault(require("@opsbase/web-ui/Accordion"));
const AccordionDetails_1 = __importDefault(require("@opsbase/web-ui/AccordionDetails"));
const AccordionSummary_1 = __importDefault(require("@opsbase/web-ui/AccordionSummary"));
const Button_1 = __importDefault(require("@opsbase/web-ui/Button"));
const react_1 = __importStar(require("react"));
const InfoPane_1 = __importDefault(require("../../OpPerformQuestionCard/InfoPane"));
const PaneAnswerIcons_1 = __importDefault(require("../../OpPerformQuestionCard/PaneAnswerIcons"));
const PaneTitle_1 = __importDefault(require("../../OpPerformQuestionCard/PaneTitle"));
const OpPerformQuestionHighlight_1 = __importDefault(require("../../OpPerformQuestionHighlight"));
const OpPerformQuestion_1 = __importDefault(require("../OpPerformQuestion"));
const makeMyClasses = inSection => ({
    textBox: {
        lineHeight: '32px',
        backgroundColor: lib_palette_1.default.White.main,
        border: `1px solid ${lib_palette_1.default.LineGrey.main}`,
        padding: '8px 16px',
        borderRadius: 8,
        width: '100%',
    },
    subTitle: {
        color: lib_palette_1.default.GreyBlue.main,
    },
    title: {},
    accordion: {
        boxShadow: 'none',
        borderRadius: `${inSection ? 8 : 16}px !important`,
        border: `1px solid ${lib_palette_1.default.LineGrey.main} !important`,
        backgroundColor: inSection ? lib_palette_1.default.WhiteSmoke.main : lib_palette_1.default.LightBlue.main,
    },
    inner: {
        width: '100%',
    },
});
function OpPerformQuestionRepetition(props) {
    var _a, _b, _c, _d, _e, _f, _g;
    const { highlightSelected } = props;
    const { question, rule } = (0, usePerformQuestion_1.default)();
    const { doDeleteRepetition, canDeleteRepetition, doAddRepetition, canAddRepetition } = (0, usePerformQuestionActions_1.default)();
    const [qTitle] = (0, useAltForSelfLang_1.default)(question === null || question === void 0 ? void 0 : question.title, question === null || question === void 0 ? void 0 : question.titleAlt);
    const rIdx = question.repetitionIndex;
    const hasSubQuestions = (_a = question.subQuestions) === null || _a === void 0 ? void 0 : _a.length;
    const [expanded, setExpanded] = (0, react_1.useState)(true);
    const [selectedTab, setSelectedTab] = (0, react_1.useState)();
    const { form, isScoreEnabled, isScorePublic, scoreText, isPreview, mode } = (0, usePerform_1.default)();
    const viewMode = mode === 'view';
    const canAdd = canAddRepetition();
    const { html, files } = rule.richInfo;
    const hasInfo = !!(html === null || html === void 0 ? void 0 : html.length) || !!(files === null || files === void 0 ? void 0 : files.length);
    const self = (0, useSelf_1.useSelf)();
    const isAllowedToSeeScore = (isPreview || viewMode) && (self.isAdmin || self.isPrimary);
    const isQuestionInSection = (0, react_1.useMemo)(() => {
        var _a;
        let q = question;
        while (q) {
            if (q.type === FormQuestionType_1.default.SECTION)
                return true;
            if (q.parentNodeId === 'root')
                return false;
            q = (_a = form === null || form === void 0 ? void 0 : form.questions) === null || _a === void 0 ? void 0 : _a[q.parentNodeId];
        }
        return false;
    }, [question, form]);
    const myCss = (0, web_css_1.default)(makeMyClasses, [isQuestionInSection]);
    const scoreTextForThisQuestion = (0, react_1.useMemo)(() => {
        // adding the scoretext here so that we can add it to the depencencies list
        if (isScoreEnabled && (isAllowedToSeeScore || isScorePublic) && scoreText) {
            const score = (0, getScore_1.default)(form, question, false);
            if (score === null || score === void 0 ? void 0 : score.max) {
                return `${score.total}/${score.max}`;
            }
        }
        else
            return null;
    }, [isScoreEnabled, isScorePublic, isAllowedToSeeScore, scoreText, form, question]);
    // Repetition
    const canDelete = !viewMode && canDeleteRepetition();
    let subTitle;
    if ((_b = rule.nTimes) === null || _b === void 0 ? void 0 : _b.enabled) {
        subTitle = `${rIdx + 1}:`;
    }
    else if ((_c = rule.unLimitedTimes) === null || _c === void 0 ? void 0 : _c.enabled) {
        subTitle = `${rIdx + 1}:`;
    }
    else if ((_d = rule.list) === null || _d === void 0 ? void 0 : _d.enabled) {
        subTitle = `${(_g = (_f = (_e = rule.list) === null || _e === void 0 ? void 0 : _e.options) === null || _f === void 0 ? void 0 : _f[rIdx]) === null || _g === void 0 ? void 0 : _g.label}:`;
    }
    const activeQuestions = (0, getEnabledQuestions_1.default)(question)
        .filter(q => q && !!q.title && q.nodeId !== question.nodeId)
        .filter(q => (0, isInSection_1.default)(form, question, q));
    const toggleShow = (0, useCallforward_1.default)(v => () => {
        setSelectedTab(selectedTab === v ? null : v);
    }, [selectedTab]);
    const infoContent = (0, react_1.useMemo)(() => {
        if (selectedTab !== 'info')
            return null;
        return react_1.default.createElement(InfoPane_1.default, { onClickClose: toggleShow(null) });
    }, [selectedTab, toggleShow]);
    const content = (0, react_1.useMemo)(() => {
        if (!hasSubQuestions)
            return null;
        return (react_1.default.createElement(Accordion_1.default, { classes: { root: myCss.accordion }, expanded: expanded, onChange: () => setExpanded(!expanded) },
            react_1.default.createElement(AccordionSummary_1.default, null,
                react_1.default.createElement(OpPerformQuestionHighlight_1.default, { highlightSelected: highlightSelected, visible: true },
                    react_1.default.createElement(Horizontal_1.default, { paddingY: true, gutter: true },
                        react_1.default.createElement(PaneTitle_1.default, { title: (subTitle || '') + ' ' + (qTitle || ''), offset: 8, bold: true }),
                        react_1.default.createElement(PaneAnswerIcons_1.default, { scoreColor: lib_palette_1.default.secondary, scoreText: scoreTextForThisQuestion }),
                        canDelete && (react_1.default.createElement(Button_1.default, { small: true, round: true, background: true, icon: react_1.default.createElement(DeleteIcon_1.default, { size: 16 }), onClick: doDeleteRepetition }))))),
            react_1.default.createElement(AccordionDetails_1.default, null,
                react_1.default.createElement(Vertical_1.default, { gutter: true, classes: { root: myCss.inner } },
                    activeQuestions.map(questionNode => (react_1.default.createElement(OpPerformQuestion_1.default, { questionNode: questionNode, highlightSelected: highlightSelected }))),
                    infoContent,
                    hasInfo && (react_1.default.createElement(Pane_1.default, { right: true },
                        react_1.default.createElement(Button_1.default, { small: true, background: selectedTab === 'info' ? false : 'transparent', color: lib_palette_1.default.secondary, label: lib_i18n_1.default.t('info'), icon: react_1.default.createElement(InfoIcon_1.default, { size: 18 }), onClick: toggleShow('info') })))))));
    }, [
        hasSubQuestions,
        myCss.accordion,
        myCss.inner,
        expanded,
        highlightSelected,
        subTitle,
        qTitle,
        scoreTextForThisQuestion,
        canDelete,
        doDeleteRepetition,
        activeQuestions,
        infoContent,
        hasInfo,
        selectedTab,
        toggleShow,
    ]);
    return (0, react_1.useMemo)(() => {
        if (!canAdd || viewMode)
            return content;
        return (react_1.default.createElement(Vertical_1.default, { shrink: true, gutter: true },
            react_1.default.createElement(Pane_1.default, null, content),
            react_1.default.createElement(Pane_1.default, { center: true },
                react_1.default.createElement(Button_1.default, { small: true, background: true, icon: react_1.default.createElement(AddIcon_1.default, null), label: lib_i18n_1.default.t('repeat-add'), onClick: doAddRepetition }))));
    }, [canAdd, content, viewMode, doAddRepetition]);
}
exports.OpPerformQuestionRepetition = OpPerformQuestionRepetition;
exports.default = OpPerformQuestionRepetition;
